import { Component, OnInit, Input } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-sms-view',
    templateUrl: './sms-view.component.html',
    styleUrls: ['./sms-view.component.scss'],
    standalone: false,
})
export class SmsViewComponent implements OnInit {
    @Input() sms;
    notDeliveredContacts: any[];
    FiStateNames = FiStateNames;

    constructor() {}

    ngOnInit() {
        this.notDeliveredContacts = this.sms.Contacts.filter(function (contact) {
            return Boolean(contact.SentErrors);
        });
    }

    /*
    getContactDeliveredStatusText(contact) {
        return contact.FullContactValue;
    };
*/
}
